<template>
  <div class="mobile-caselist-page-case">
    <div class="mobile-caselist-header-box"></div>
    <ContentBottom :list="imgData" @toInfo="toInfo" />
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/MobileIframe/components/Footer";
import { pageApi } from "@/api";
import _ from "lodash";
import ContentBottom from "./components/ContentBottom";
export default {
  components: {
    Footer,
    ContentBottom,
  },
  data() {
    return {
      imgData: [],
      index: 0,
    };
  },
  mounted() {
    this.index = this.$route.query.index;
    this.getcaseList();
  },
  methods: {
    async getcaseList() {
      const res = await pageApi.getCaseList();
      this.imgData = res.result[this.index]["list"];
    },
    toInfo(id) {
      this.$router.push({ name: "phone-caseInfo", query: { id } });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./index.scss";
</style>
